import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'ServiceDestinations/All', method: 'GET', body: null, token: token })
}
